import React from "react";
import { Button, ButtonProps } from "@chakra-ui/react";
import { FiArrowRight } from "@react-icons/all-files/fi/FiArrowRight";
import { Link as GatsbyLink, graphql, useStaticQuery } from "gatsby";
import { HomePageSection, HomePageSectionHeading } from "./HomePage";
import { HomePageTutorialGrid } from "./HomePageTutorialGrid";

export function HomePageRecentTutorials() {
  const data = useStaticQuery<Queries.ListRecentTutorialsQuery>(graphql`
    query ListRecentTutorials {
      recentTutorials: allCourse(
        filter: {
          memberships: { eq: null }
          tiers: { eq: null }
          unlisted: { ne: true }
        }
        sort: { fields: date, order: DESC }
        limit: 3
      ) {
        nodes {
          ...HomePageTutorial
        }
      }
    }
  `);

  return (
    <HomePageSection
      mb={{
        base: 10,
        md: 8,
        lg: 0,
      }}
    >
      <HomePageSectionHeading
        title="Recently updated"
        description="Check out our latest materials!"
      />
      <HomePageTutorialGrid
        mb={{ base: 8, lg: 12 }}
        tutorials={data.recentTutorials.nodes}
      />
      <CatalogButton />
    </HomePageSection>
  );
}

export function CatalogButton(props: ButtonProps) {
  return (
    <Button
      size="lg"
      colorScheme="indigo"
      variant="link"
      rightIcon={<FiArrowRight />}
      as={GatsbyLink}
      to="/browse"
      {...props}
    >
      Explore our entire catalog
    </Button>
  );
}
